import LinkRadioContainer from 'data/redux/containers/linkRadioContainer/LinkRadioContainer';
import Editor from 'gui/components/editors/commons/editor/Editor';
import React from 'react';
import PreparedTopEditorSection from '../preparedTopEditorSection/PreparedTopEditorSection';


export interface IVoucherOrOrderRadioProps {
  labelTrue?: string;
  labelFalse?: string;
  linkTrue?: string;
  linkFalse?: string;
}

const VoucherOrOrderRadio = (props: IVoucherOrOrderRadioProps) =>
  (<PreparedTopEditorSection title={"מה סוג המודעה שאתם עומדים לפרסם?"}>
    <LinkRadioContainer
      labelTrue={props.labelTrue}
      labelFalse={props.labelFalse}
      linkTrue={Editor.currentRoute(props.linkTrue, 0)}
      linkFalse={Editor.currentRoute(props.linkFalse, 0)}
    />
  </PreparedTopEditorSection>);

VoucherOrOrderRadio.defaultProps = {};

export default VoucherOrOrderRadio;
